import React, { useEffect, useState } from "react";
import Iframe from 'react-iframe'
const InstagramCard = ({ item, styles }) => {

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Add a window resize event listener to update minHeight when the window size changes.
    function handleResize() {
      setWidth(window.innerWidth);
    }

    // Initial call to set the minHeight based on the current window size.
    handleResize();

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const coloum_value = JSON.parse(item?.coloum_value);
 
  const [iframeUrl, setIframeUrl] = useState(null);
  const [isGuide, setIsGuide] = useState(false);
  function transformInstagramGuideURL(url) {
    // Split the URL into parts using '/' as a delimiter
    const parts = url.split('/');
    // Check if the URL matches the expected pattern
    if (parts[4] === "guide") {
      // Replace the pattern with the desired format
      parts[5] = "_";
      
      // Join the parts back into a URL
      const transformedURL = parts.join('/');
      
      return transformedURL;
    }
  
    // If the URL doesn't match the expected pattern, return it as is
    return url;
  }
  useEffect(() => {

    var lastLetter =
    coloum_value?.coloum_value?.[coloum_value?.coloum_value?.length - 1];
    if (lastLetter === "/") {
      const newStr = coloum_value?.coloum_value?.slice(0, -1);
      if(newStr.includes("guide")){
        setIsGuide(true);
        setIframeUrl(`${transformInstagramGuideURL(newStr)}/embed`);
      } else{
        setIsGuide(false);
        setIframeUrl(`${newStr}/embed/captioned`);
      }
    } else {
      const newStr = coloum_value?.coloum_value;
      if(newStr.includes("guide")){
        setIsGuide(true);
        setIframeUrl(`${transformInstagramGuideURL(newStr)}/embed`);
      } else{
        setIsGuide(false);
        setIframeUrl(`${newStr}/embed/captioned`);
      }
    }
  }, [coloum_value])

  return (
    <div className="w-full">
     <Iframe url={iframeUrl} width="100%" height="100%" className={`rounded-lg overflow-auto`} position="inherit" styles={{minHeight:isGuide ? width < 768 ? '380px':'780px': width < 768 ? '480px':'1050px'}} />
    </div>
  );
};

export default InstagramCard;
// src={`${coloum_value?.coloum_value}embed/captioned`}
